/* eslint-disable no-unused-vars */
import React from 'react';

import PopUp from '../../Popup';
import PowerEventUpgrade from './PowerEventUpgrade';
import CheckoutForm from '../../CheckoutForm';

class UpgradeToProClubPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCheckout: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.getFormType = this.getFormType.bind(this);
        this.getFooterText = this.getFooterText.bind(this);
    }

    getFormType() {
        const { clubTierType } = this.props;
        switch (clubTierType?.name?.toLowerCase()) {
            case 'free college':
                return 'pro_club_college';
            case 'pro':
                return 'pro_club';
            case 'high school':
                return 'performance_hs_club';
            default:
                return 'pro_club';
        }
    }

    getFooterText() {
        const { clubTierType } = this.props;
        switch (clubTierType?.name?.toLowerCase()) {
            case 'free college':
                return (
                    'Please complete the above steps within 30 days to remain on UTR Sports College at the $99 promotion. \n' +
                    'Have any questions on how to complete these steps? Contact us as college@universaltennis.com');
            default:
                return null;
        }
    }

    handleClick(ev) {
        this.setState({ showCheckout: true });
    }

    handleSuccess() {
        this.props.onSuccess();
    }

    render() {
        const { showCheckout } = this.state;
        const { onCloseClick, titleInfoOnClick, clubName, 'data-testid': dataTestId } = this.props;
        const formType = this.getFormType();
        const footerText = this.getFooterText();
        return (
            <div data-testid={dataTestId}>
                <PopUp
                    className="popup-md"
                    config={{
                        style: {
                            height: formType === 'pro_club_college' ? 720 : 640,
                            maxHeight: formType === 'pro_club_college' ? '90vh' : '80vh',
                        },
                        fullScreen: true,
                        noPadding: false,
                        topGradient: true,
                    }}
                    onCloseClick={onCloseClick}
                >
                    {(showCheckout || this.props.skipIntro)
                        ? (
                            <CheckoutForm
                                clubId={this.props.clubId}
                                formType={formType}
                                onComplete={this.handleSuccess}
                                footerText={footerText}
                                titleInfoOnClick={titleInfoOnClick}
                                clubName={clubName}
                            />
                        )
                        : (
                            <PowerEventUpgrade
                                onClick={this.handleClick}
                                data-testid={dataTestId ? `${dataTestId}.power-upgrade` : undefined}
                            />
                        )}
                </PopUp>
            </div>
        );
    }
}

export default UpgradeToProClubPopUp;
